import constant from './../reducers/actionConstants';

const { ERROR } = constant;

export const setErrorMessage = payload => {
  return { type: ERROR , payload }
}